import { useAppDispatch, useAppSelector } from 'hooks';
import { FC } from 'react';
import { selectEstimateNotes, updateEstimateNotes } from '../../estimatesSlice';
import { CustomTextArea } from 'components';
import { VoidFn } from 'types/baseTypes';

interface EstimateNotesSectionProps {
  className?: string;
  handleOnFocus: VoidFn;
}

const EstimateNotesSection: FC<EstimateNotesSectionProps> = ({ className, handleOnFocus }) => {
  const selectedEstimateNotes = useAppSelector(selectEstimateNotes);
  const dispatch = useAppDispatch();

  const handleNoteChange = (value: string) => {
    dispatch(updateEstimateNotes(value));
  };

  return (
    <div className={className}>
      <div className="mb-2 text-17px font-semibold text-heading">Notes</div>
      <div className="mb-4">
        <CustomTextArea
          resizeTextArea={true}
          id="create-estimate-notes"
          maxLength={1000}
          name="notes"
          placeholder="Enter notes here"
          value={selectedEstimateNotes ?? ''}
          onChange={handleNoteChange}
          className="py-[15px] text-[17px] font-normal leading-5
            text-heading outline-none placeholder:text-[17px]"
          onFocus={handleOnFocus}
          showRemainingChar={true}
        />
      </div>
    </div>
  );
};

export default EstimateNotesSection;
